<template lang="html">
    <div class="all">
        <h4>New Smart Link</h4>
        <Campaign :onSubmit='submit' :isVta='isVta' />
    </div>
</template>

<script>
import Campaign from './components/Campaign'
export default {
    props: {
        isVta: Boolean,
        workspace: Boolean
    },
    components: {
        Campaign
    },
    methods: {
        submit: async function (form) {
            const route = this.$route.fullPath
            try {
                const r = await this.$http.post(this.resources.SmartLinksCampaigns.postCampaign, form)
                const created = await r.json()
                created.stats = created.stats || {}
                let camps = this.$store.state.smartlinks
                if (!camps.campaigns) {
                    camps.campaigns = [created]
                } else {
                    camps.campaigns.unshift(created)
                }
                this.$emit('close')
                if (this.workspace) {
                    this.$router.push({
                        name: 'SmartLinksV2Workspace',
                        params: { campId: created.id }
                    })
                    return
                }
                this.$router.push({
                    name: route.includes("VTA") ? "SmartLinksVTAId" : "SmartLinksId",
                    params: {
                        campId: created.id
                    }
                })

            } catch (err) {
                this.notifyError("Could not create Smart Link")
            }
        }
    }
}
</script>

<style lang="css" scoped></style>
